export const STATUS_ENUM = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
};
